import { render, staticRenderFns } from "./ProductListByCategory.vue?vue&type=template&id=2fe43be4&scoped=true"
import script from "./ProductListByCategory.vue?vue&type=script&lang=js"
export * from "./ProductListByCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductListByCategory.vue?vue&type=style&index=0&id=2fe43be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe43be4",
  null
  
)

export default component.exports